import useListen from '@pkg/broadcasting/useListen';
import useObservable from '@pkg/broadcasting/useObservable';
import useFetch from './useFetch';

export default function useNotify() {
  const { fetch } = useFetch();
  const channelType = 'PrivateChannel';
  const channelName = 'Access.notify';
  const listeners = [
    {
      event: '.access.updated',
      context: 'access',
      callback: fetch,
    },
  ];

  const notify = useObservable(channelName, listeners);
  useListen({ channelName, channelType }, notify);
}
